import React, { useState } from 'react'
import { Form, Input, Modal, Button, App } from 'antd';
import Icon from '../../cpn/Icon';
import { useKhlxrAddMutation } from '../../store/DianShangYeWuApi';
function ClientContactAdd(props) {
    const { message } = App.useApp();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const [submit] = useKhlxrAddMutation();
    const [info, setInfo] = useState({
        'khlxr_qy_id': props.qy_id,     
        'khlxr_qy_name': props.qy_name,
        'khlxr_kh_id': props.kh_id,
        'khlxr_kh_name': props.kh_name,
        'khlxr_name': '',
        'khlxr_phone': '',
        'khlxr_content': '',        
        'khlxr_uid': props.yh_id,
        'khlxr_uname': props.yh_name
    });
    return (
        <>
            <Icon type='add' onClick={() => {setOpen(true)}} title='新增部门'/>
            <Modal
                open={open}
                title='新增部门'
                width={800}
                onCancel={() => {setOpen(false)}}
                footer={[
                    <Button key='submit' type='primary' onClick={() => {
                        submit(info).then(res => {
                            if(res.data.Status === 'success'){
                                message.success('新增成功');
                                setOpen(false);
                                form.resetFields();
                                setInfo(prevState=>({...prevState,khlxr_name:'',khlxr_phone:'',khlxr_content:''}))
                            }else{
                                message.error('新增失败'+res.data.Message);
                            }
                        });
                    }}>保存</Button>,
                    <Button key='reset' onClick={() => {
                        form.resetFields();
                        setInfo(prevState=>({...prevState,khlxr_name:'',khlxr_phone:'',khlxr_content:''}))
                    }}>重置</Button>,
                ]}
            >
                <Form  
                    form={form} 
                    name='form_client_contact_add' 
                    labelCol={{span: 4}} 
                    wrapperCol={{span: 20}}
                    onFinish={() => {
                        console.log(form.getFieldsValue());
                    }}
                >  
                    <Form.Item 
                        name='khlxr_name' 
                        label='部门名称' 
                        rules={[{ required: true, message: '请输入部门名称' }]}
                    >  
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,khlxr_name:e.target.value}))
                        }}/>
                    </Form.Item>
                    <Form.Item 
                        name='khlxr_phone' 
                        label='电话' 
                        
                    >  
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,khlxr_phone:e.target.value}))
                        }}/>
                    </Form.Item>
                    <Form.Item 
                        name='khlxr_content' 
                        label='备注' 
                       
                    >  
                    <Input onChange={(e) => {
                        setInfo(prevState=>({...prevState,khlxr_content:e.target.value}))
                    }} /></Form.Item>
                </Form>
            </Modal>
        </>
    )
    }

export default ClientContactAdd